<section
  [ngClass]="{
    'show--on--counter': showAfterContainer.showAfter && showAfterContainer.showAfter === showAfterContainer.counter
  }"
  class="read-more-from-wrapper">
  <h1 class="read-more-from-wrapper__title">
    {{title}}
  </h1>
  <div class="read-more-from-wrapper__elements">
    <a
      *ngFor="let note of notesList"
      [routerLink]="note.shortURLPath ? ['/n', note.shortURLPath] : ['/notes', note.id, note.indexedName || note.name || note.id]"
      class="read-more-from-wrapper__elements__element">
      <h2
        class="read-more-from-wrapper__elements__element__title">{{note.name}}</h2>
      <p
        [ngClass]="{'text--limit': useTextLinesLimit}"
        class="read-more-from-wrapper__elements__element__text">{{note.firstLeadWords}}</p>
  </a>
  </div>
  <h2 
    class="read-more-from-wrapper__bg-stamp"
    *ngIf="category">{{category}}</h2>
</section>